import React from "react";
import { Route, Switch } from "react-router-dom";
import routes from "router/routes";
import { makeStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import './index.scss';
import PerfectScrollbar from 'react-perfect-scrollbar';
import styles from "assets/jss/material-dashboard-react/layouts/userStyle.js";
import { Helmet } from "react-helmet";
import AppUtil from "../utilities/AppUtil";
import { Box } from "@material-ui/core";

const useStyles = makeStyles(styles);
const customUseStyles = makeStyles({
  adminContent: {
    padding: '1.5rem',
    margin: '20px',
    backgroundColor: '#FFFFFF',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25), inset 0px 4px 4px rgba(0, 0, 0, 0.25)',
    borderRadius: '21px'
  },
  formContent: {
    backgroundColor: '#00000059',
  },
  wrap: {
    display: 'flex',
    justifyContent: 'center'
  },
  console: {
    height: '100vh',
    paddingTop: 50,
    display: "flex"
  },
  publicPage: {
    paddingTop: 0
  }
});


const Public = () => {
  const classes = useStyles();
  const customClasses = customUseStyles();

  const switchRoutes = (
    <Switch>
      {routes.map((prop, key) => {
        if (prop.layout === "/public") {
          let classNamses = customClasses.adminContent;
          if (prop.path === '/complaint/form' || prop.path === '/intake-link/form/:token') {
            classNamses = customClasses.formContent;
          }
          return <Route
            path={`${prop.layout}${prop.path}`}
            component={() => (
              <React.Fragment>
                <div className={classNamses}>
                  <prop.component route={prop} />
                </div>
              </React.Fragment>
            )}
            key={key}
          />;
        }
        return null;
      })}
      {/* <Redirect from="/" to="/home" /> */}
    </Switch>
  );

  return (
      <PerfectScrollbar
          className={classNames({
            "user-console": true,
            // [customClasses.console]: isAdmin || isUser
          })}
          options={{
            suppressScrollX: true,
            suppressScrollY: false
          }}
          id="main-panel"
      >
        <Helmet>
          <title>{AppUtil.makeBrand(routes)}</title>
        </Helmet>
        <Box display="flex" width="100%">
          <Box flex="1 auto" overflow="hidden" height="fit-content">
            <div
                className={classNames({
                  [classes.mainPanel]: true,
                  [customClasses.publicPage]: true
                })}
            >
              <div>{switchRoutes}</div>
            </div>
          </Box>
        </Box>
      </PerfectScrollbar>
  );
}

export default Public;
